export function UnknownContent() {
    return <></>;
}

export interface UnknownContentProps {
}

export default UnknownContent;